import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

import client1 from "@/assets/clients/client1.png";
import client2 from "@/assets/clients/client2.png";
import client3 from "@/assets/clients/client3.png";
import client4 from "@/assets/clients/client4.png";
import client5 from "@/assets/clients/client5.png";
import client6 from "@/assets/clients/client6.png";
import client7 from "@/assets/clients/client7.png";
import client8 from "@/assets/clients/client8.png";
import client9 from "@/assets/clients/client9.png";
import client10 from "@/assets/clients/client10.png";
import client11 from "@/assets/clients/client11.png";
import client12 from "@/assets/clients/client12.png";

const fallbackClients = [client1, client2, client3, client4, client5, client6, client7, client8, client9, client10, client11, client12];

const ClientsCarousel = () => {
  const [clients, setClients] = useState<string[]>(fallbackClients);
  const [logoSize, setLogoSize] = useState({ width: 166, height: 104 });
  const [slideDuration, setSlideDuration] = useState(30);

  useEffect(() => {
    const fetchData = async () => {
      const { data: logos } = await supabase
        .from("client_logos")
        .select("image_url")
        .order("display_order");
      if (logos && logos.length > 0) {
        setClients(logos.map((l: any) => l.image_url));
      }

      const { data: sizeSettings } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "client_logo_size")
        .single();
      if (sizeSettings?.value) {
        const val = sizeSettings.value as { width: number; height: number };
        setLogoSize(val);
      }

      const { data: speedSettings } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "client_slide_speed")
        .single();
      if (speedSettings?.value) {
        const val = speedSettings.value as { duration: number };
        setSlideDuration(val.duration);
      }
    };
    fetchData();
  }, []);

  return (
    <section className="py-20 overflow-hidden" style={{ backgroundColor: '#f9f9f9' }}>
      <div className="max-w-7xl mx-auto px-4 mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-[#272727] text-center tracking-wide">
          Nossos <span className="text-primary">Parceiros</span>
        </h2>
      </div>
      <div className="relative overflow-hidden">
        <div
          className="flex w-max"
          style={{
            animation: `scroll-logos ${slideDuration}s linear infinite`,
          }}
        >
          {[...clients, ...clients, ...clients].map((logo, i) => (
            <div
              key={i}
              className="flex-shrink-0 mx-6 flex items-center justify-center transition-transform duration-300 hover:scale-110"
              style={{ width: `${logoSize.width / 16}rem`, height: `${logoSize.height / 16}rem` }}
            >
              <img src={logo} alt={`Parceiro ${(i % clients.length) + 1}`} className="max-w-full max-h-full object-contain" loading="lazy" width={logoSize.width} height={logoSize.height} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsCarousel;
